module.exports = __webpack_public_path__ + "img/isaac-table.314cecef.svg";